import * as React from "react";
import { cn } from "../../../helpers";
import styles from "./Button.module.scss";

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: "primary" | "secondary" | "normal" | "ghost" | "danger";
    mode?: "filled" | "outline";
    size?: "small" | "auto" | "medium" | "icon";
    type?: "button" | "reset" | "submit";
    children: React.ReactNode;
    className?: string;
    iconLeft?: React.ReactElement;
    iconRight?: React.ReactElement;
    outlineClass?: string;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
    (
        {
            variant = "primary",
            size = "small",
            type = "button",
            mode = "filled",
            children,
            className,
            iconLeft,
            iconRight,
            outlineClass,
            ...props
        },
        ref
    ) => {
        const variantClass =
            variant === "primary"
                ? mode === "outline"
                    ? styles.primaryOutline
                    : styles.primaryFilled
                : variant === "secondary"
                ? styles.secondary
                : variant === "danger"
                ? mode === "outline"
                    ? styles.dangerOutline
                    : styles.danger
                : styles.normal;

        const sizeClass =
            size === "small"
                ? styles.small
                : size === "medium"
                ? styles.medium
                : size === "icon"
                ? styles.icon
                : styles.auto;

        return (
            <button
                className={cn(
                    styles.button,
                    variantClass,
                    sizeClass,
                    (iconLeft || iconRight) && styles.hasIcon,
                    className
                )}
                type={type}
                ref={ref}
                {...props}
            >
                {iconLeft}
                {children}
                {iconRight}
            </button>
        );
    }
);

Button.displayName = "Button";
export { Button };
